<template>
  <div 
    class="table-view"
    :class="`${sport}-table-view`">
    <div
      v-for="(item, idx) in tableData"
      :key="item + idx"
      class="table-section">
      <b-table-simple
        fixed
        bordered>
        <b-thead
          v-if="idx === 0">
          <b-tr>
            <b-th 
              v-for="field in fields"
              :key="field.key"
              :class="field.thClass"
              :rowspan="field.key !== 'bet' ? 2 : 1"
              :colspan="field.key === 'bet' ? 2 : 1">
              {{field.label}}
            </b-th>
          </b-tr>
          <b-tr>
            <b-th class="ds-col yellow">客場胜</b-th>
            <b-th class="ds-col yellow">客場负</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-for="(row, i) in item"
            :key="i + row">
            <b-td
              v-for="(field, colidx) in fields" 
              v-show="i % 2 == 0 || i % 2 !== 0 && (field.key !== 'serialno' && field.key !== 'league' && field.key !== 'play_at' && field.key !== 'team')"
              :colspan="field.key === 'bet' ? 2 : 1"
              :rowspan="i % 2 == 0 && (field.key == 'serialno' || field.key == 'league' || field.key == 'play_at' || field.key === 'team') ? 2 : 1"
              :key="field + colidx"
              :class="field.tdClass">
              <div 
                v-if="field.key === 'play_at' || field.key === 'spread' || field.key === 'score'"
                :class="{'flex flex-around': field.key === 'score'}"
                v-html="row[field.key]">
              </div>
              <div
                v-else-if="field.key === 'team'"
                class="flex flex-around">
                <div>
                  <div class="red">客</div>
                  <div>{{row.team.away_team}}</div>
                </div>
                <div>VS</div>
                <div>
                  <div class="red">主</div>
                  <div>{{row.team.home_team}}</div>
                </div>
              </div>
              <div
                v-else-if="field.key === 'bet'"
                class="flex flex-around">
                <div>
                  <span>{{row.bet.win_rate}}</span>
                </div>
                <div>
                  <span>{{row.bet.lose_rate}}</span>
                </div>
              </div>
              <div v-else>{{row[field.key]}}</div>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data', 'sport'],
  data () {
    return {
      result: null,
      fields: [
        { key: 'serialno', label: '场次', tdClass: 'serialno-col', thClass: 'serialno-col'},
        { key: 'league', label: '赛事', tdClass: 'league-col', thClass: 'league-col'},
        { key: 'play_at', label: '比赛时间', tdClass: 'play_at-col', thClass: 'play_at-col'},
        { key: 'team', label: '主场', tdClass: 'team-col', thClass: 'team-col'},
        { key: 'score', label: '比分', tdClass: 'score-col', thClass: 'score-col'},
        { key: 'spread', label: '让分', tdClass: 'spread-col', thClass: 'spread-col'},
        { key: 'bet', label: '投注', tdClass: 'bet-col', thClass: 'bet-col'},
      ],
      resultCode: {
        0: '主負',
        1: '平手',
        3: '主胜'
      }
    }
  },
  computed: {
    tableData: {
      get () {
        return this.result
      },
      set (data) {
        let arr = []
        if (data) {
          arr = data.map(item => {
            return this.handleData(item)
          })
        }
        this.result = arr
      }
    }
  },
  created () {
    this.tableData = this.data
  },
  watch: {
    data (cur, prev) {
      if (cur !== prev) 
        this.tableData = this.data
    }
  },
  methods: {
    handleData (obj) {
      let arr = []
      if (!obj)
        return arr
      for(let i = 0; i < 2; i++) {
        let serial = this.serialNum(String(obj.serialno)) || obj.serialno
        let sflf = obj.sflf, firstCol = i % 2 === 0, 
            awayRateObj = {}, homeRateObj = {}
        let spread = firstCol ? sflf.away_point_spread || '-' : sflf.home_point_spread || '-'
        let color = Number(spread) < 0 ? 'green' : Number(spread) > 0 ? 'red' : 'normal'
        for(let key in sflf) {
          if (firstCol && key.indexOf('away') > -1)
            awayRateObj[key.replace('away_', '')] = sflf[key]
          else
            homeRateObj[key.replace('home_', '')] = sflf[key]
        }
        let reateObj = firstCol ? awayRateObj : homeRateObj
        arr.push({
          serialno: typeof(serial) === 'object' ? serial[i] : serial,
          league: obj.league,
          play_at: obj.play_at,
          team: {
            home_team: obj.home_team,
            away_team: obj.away_team,
          },
          score: `<span class="red">${firstCol ? '客' : '主'}</span>${firstCol ? obj.away_team_score || '-' : obj.home_team_score || '-'}`,
          spread: `<div class="spread-${color}">${spread}</div>`,
          bet: reateObj
        })
      }
      return arr
    },
    serialNum (str) {
      return str.indexOf('-') > -1 ? str.split('-') : null
    },
    handleWinLose (code) {
      return code !== '-' ? `(${this.resultCode[code]})` : ''
    }
  }
}
</script>

<style lang="scss">

</style>